import { memo } from 'react';

import {
  BtnGroup,
  BtnToolbar,
  Button,
  ButtonAction,
  Col,
  Combobox,
  type HookFormMethods,
  HookFormResolver,
  Number,
  Row,
  Text
} from '@dec/shared';
import { useTranslation } from 'react-i18next';

import { useGetAllFormStatement } from '@/app/modules/TaxStatement/FormAdministration/hooks';

import { type TaxReturnFilter } from './search';

interface SelectTaxReturnFiltersProps {
  onSearch: (filter: TaxReturnFilter) => void;
  onClear: () => void;
}

export const SelectTaxReturnFilters = memo(({ onSearch }: SelectTaxReturnFiltersProps) => {
  const { t } = useTranslation();

  const { data: forms, loading: loadingForms } = useGetAllFormStatement();

  return (
    <HookFormResolver onSubmit={onSearch} initialValues={{ relations: ['FormVersion.Form'] }}>
      {({ reset }: HookFormMethods) => {
        return (
          <>
            <Row>
              <Col lg={6} xl={6} md={6}>
                <Text label={t('config.tin')} name="tin" />
              </Col>
              <Col>
                <Combobox
                  data={!loadingForms ? forms : []}
                  code={'id'}
                  display={'shortName'}
                  label={t('taxReturns.taxReturnForm')}
                  name="formId"
                />
              </Col>
              <Col>
                <Number label={t('common.label.period')} name="period" />
              </Col>
            </Row>

            <BtnToolbar>
              <BtnGroup>
                <Button
                  action={ButtonAction.clean}
                  type={'reset'}
                  onClick={() => {
                    // onSearch({});
                    reset({
                      formId: null,
                      period: null,
                      taxReturnState: 'accepted',
                      active: true,
                      relations: ['FormVersion.Form']
                    });
                  }}
                />
              </BtnGroup>
              <BtnGroup>
                <Button action={ButtonAction.find} type={'submit'} variant={'primary'} />
              </BtnGroup>
            </BtnToolbar>
          </>
        );
      }}
    </HookFormResolver>
  );
});

SelectTaxReturnFilters.displayName = 'PaymentFilters';
